











































import Vue, { PropType } from "vue";
import { LicenseDetail } from "@/models/license";
import validationMixin from "@/components/mixins/validationMixin";
import LicenseService from "@/services/licenseService";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import VaButton from "@/components/atoms/VaButton.vue";

export default Vue.extend({
  name: "ChoseLicenseForm",
  mixins: [validationMixin],
  components: { VaButton },
  props: {
    value: {
      type: Object as PropType<LicenseDetail | undefined>,
    },
    deviceConfiguration: {
      type: Object as PropType<DeviceConfiguration>,
    },
  },
  data() {
    return {
      licenses: [] as Array<LicenseDetail>,
      license: this.value,
      loading: false,
    };
  },
  beforeMount() {
    this.loadLicenses();
  },
  watch: {
    value: function (newVal) {
      this.license = newVal;
    },
  },
  methods: {
    async loadLicenses(): Promise<void> {
      try {
        this.loading = true;
        this.licenses = await (
          await LicenseService.get(
            this.android,
            this.deviceConfiguration.deviceType,
            this.deviceConfiguration.tenantCode
            // this.android ? this.deviceConfiguration.tenantCode : undefined
          )
        ).filter((license: LicenseDetail) => {
          return license.isRoom || license.isPod;
        });
      } catch (e) {
        this.licenses = [] as Array<LicenseDetail>;
        this.$notification.error(e);
        this.$sentry.capture(e, "wizard", "loadLicenses");
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    isOnPrem(): boolean {
      return this.$store.getters["onprem/isOnPrem"];
    },
    android(): boolean {
      return this.deviceConfiguration?.deviceType === "AndroidReceiver";
    },
  },
});
